import { Component, OnDestroy, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { OeeService } from '../../../services/oee.service';

@Component({
  selector: 'tt-oee-dash-board',
  templateUrl: './oee-dash-board.component.html',
  styleUrls: ['./oee-dash-board.component.css']
})
export class OeeDashBoardComponent implements OnInit, OnDestroy {
    private reload!: ReturnType<typeof setInterval>;

    public itemsListOeeDashboard: Item[] = [];

    constructor(private oeeService: OeeService) {

    }

    private async loadOeeDashboard() {
        this.itemsListOeeDashboard = await this.oeeService.listOeeDashBoard();
    }

    private async reloadInterval() {
        this.oeeService.reloadOeeDashboard();
        this.loadOeeDashboard();
    }

    private async init() {
        this.loadOeeDashboard();

        this.reload = setInterval(() => this.reloadInterval(), 30000);
    }

    ngOnInit() {
        this.init();
    }

    ngOnDestroy(): void {
        clearInterval(this.reload);
    }
}
